export default "__VITE_ASSET__C4Z$ZLv2__"